import { render, staticRenderFns } from "./splash-image.vue?vue&type=template&id=3b6db896&scoped=true&"
import script from "./splash-image.vue?vue&type=script&lang=js&"
export * from "./splash-image.vue?vue&type=script&lang=js&"
import style0 from "./splash-image.vue?vue&type=style&index=0&id=3b6db896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6db896",
  null
  
)

export default component.exports